import type { ReactNode } from 'react';

import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';

interface AppToolTipProps {
  children: ReactNode;
  content: string;
  side?: 'top' | 'right' | 'bottom' | 'left';
  align?: 'start' | 'center' | 'end';
  delayDuration?: number;
}

export function AppToolTip({
  children,
  content,
  side = 'bottom',
  align = 'center',
  delayDuration = 150,
}: AppToolTipProps) {
  return (
    <TooltipProvider delayDuration={delayDuration}>
      <Tooltip>
        <TooltipTrigger asChild>{children}</TooltipTrigger>

        <TooltipContent
          side={side}
          align={align}
          sideOffset={6}
          className="
              bg-popover
              text-popover-foreground
              border-border/60
              z-[100]
              rounded-md
              border
              px-2.5
              py-1.5
              text-xs
              font-medium
              shadow-lg
            "
        >
          {content}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
